import { useLocation } from "react-router";

import {
    LogoTrello,
    useAnalytics,
    useAnalyticsAttributes
} from "../../../components";

import LogoLink from "./Logo.styles";

type LogoProps = {
    id: string;
    eyebrow?: boolean;
};

const Logo = ({ id, eyebrow }: LogoProps) => {
    const HOMEPAGE_PATHNAME = "/home";
    const location = useLocation();
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();

    return (
        <LogoLink
            aria-current={
                location?.pathname === HOMEPAGE_PATHNAME ? "page" : undefined
            }
            href={HOMEPAGE_PATHNAME}
            onClick={() =>
                sendTrackEvent("clickedUiHeaderNavLogo", {
                    ...analyticsAttributes,
                    event: "clicked",
                    eventComponent: "logo",
                    label: "Trello logo",
                    labelEnglish: "Trello logo",
                    uuid: `${id}_logo`,
                    href: HOMEPAGE_PATHNAME
                })
            }
            data-uuid={`${id}_logo`}
            testId="logo_link"
        >
            <LogoTrello
                height={eyebrow ? 37.5 : 22.5}
                appearance="blue"
                id={id}
                eyebrow={eyebrow}
            />
        </LogoLink>
    );
};

export default Logo;
